// extracted by mini-css-extract-plugin
export default {"content":"project_content__a88rY"};